import { API_ADMIN_URL } from '../../../config/constants';
import { postRequest } from '../../API';

/*********************************************************
 * Function Name : list
 * Description   : Get paginated list of bw_transactions
 * By            : Afsar Ali
 * Date          : 11-06-2025
 *********************************************************/
export const list = async (options) => {
    try {
        const params = {
            url: `${API_ADMIN_URL}transactions/list`,
            postData: options,
        };
        const res = await postRequest(params);
        if (res.status === true || res.status === 200) {
            return { status: true, result: res?.data?.response?.result, count: res?.data?.response?.count };
        } else {
            return { status: false, message: res?.response?.data?.statusMessage };
        }
    } catch (error) {
        return { status: false, message: 'Under Maintenance, Please try after some time.' };
    }
}; //End of Function

/*********************************************************
 * Function Name : view
 * Description   : Get single bw_transaction by _id
 * By            : Afsar Ali
 * Date          : 11-06-2025
 *********************************************************/
export const view = async (options) => {
    try {
        const params = {
            url: `${API_ADMIN_URL}transactions/view`,
            postData: options,
        };
        const res = await postRequest(params);
        if (res.status === true || res.status === 200) {
            return { status: true, result: res?.data?.response?.result };
        } else {
            return { status: false, message: res?.response?.data?.statusMessage };
        }
    } catch (error) {
        return { status: false, message: 'Under Maintenance, Please try after some time.' };
    }
}; //End of Function
